import React, { useMemo, useState } from 'react';

import { FormControlLabel, Radio, RadioGroup, Typography, withStyles } from '@material-ui/core';

import './style.scss'
import { useDispatch, useSelector } from 'react-redux';
import { useParams } from 'react-router-dom';
import { doAddBulkCredentials, doAddSingleCredential } from '../../../../../../redux/thunks/credentials';
import SuccessTick from '../../../../../../assets/svgComponent/SuccessTick';
import { selectOrganisation } from '../../../../../../redux/selectors/organisation';
import BulkUploadCredential from './BulkUploadCredential';
import GenerateNewCredential from '../Forms/GenerateNewCredential';
import { validEmail } from '../../../../../../helpers/utils/formValidations';
import Dropdown from '../../../../../../components/Inputs/Dropdown';
import { credTypes, dynamicQrInfo, dynamicQRTypes, staticQrInfo, staticQRTypes } from '../helper';
import SDialog from '../../../../../../components/SDialog/SDialog';
import FlexColumn from '../../../../../../components/FlexBox/FlexColumn';
import useIsMobile from '../../../../../../hooks/useIsMobile';


const StyledRadio = withStyles({
  root: {
    color: '#BDC7D9',
    '&$checked': {
      color: '#03BFFF',
    },
  },
  checked: {},
})((props) => <Radio color="default" {...props} />);


const AddCredentialDialog = ({ open, onClose, onSuccess }) => {

  const { customerId } = useParams();

  const isMobile = useIsMobile();
  const dispatch = useDispatch();

  const { organisation } = useSelector((state) => ({
    organisation: selectOrganisation(state),
  }));

  const [step, setStep] = useState(1);
  const [assignmentMethod, setAssignmentMethod] = useState({ id: 0, name: '' })//1=Generate New, 2=Existing
  const [credentialRequired, setCredentialRequired] = useState("1")//1=single New, 2=Multiple
  const [credentialType, setCredentialType] = useState({ id: '', name: '' });
  const [selectedFormat, setSelecetdFormat] = useState({ id: 'generic_32_bit', name: 'Generic 32-bit' });
  const [email, setEmail] = useState('');
  const [credentialId, setCredentialId] = useState('');
  const [userName, setUserName] = useState('');
  const [bulkSteps, setBulkSteps] = useState(1);
  const [bulkAddData, setBulkAddData] = useState([]);
  const [selectedQRType, setSelecetdQRType] = useState({ id: 0, name: '' });
  const [qrMode, setQrMode] = useState("1");//1=Static, 2=Dynamic
  const [infoDialog, setInfoDialog] = useState(false);
  const [success, setSuccess] = useState(false);

  const popupToggle = () => {
    onClose();
  };

  const hDisable = useMemo(() => {
    const type1Validation = (!userName || !email || !selectedFormat?.id || !credentialType?.id || !validEmail(email));
    const type2Validation = (!userName || !email || !selectedFormat?.id || !credentialType?.id || !credentialId || !validEmail(email));
    if (step === 1 && !assignmentMethod?.id || !credentialType?.id || ((credentialRequired === '1' && credentialType?.id === 'qr') ? !selectedQRType?.id : false)) {
      return true
    } else if (step > 1 && credentialRequired === '2' && bulkSteps === 3 && bulkAddData?.filter(b => b?.errorMessage?.length > 2)?.length > 0) {
      return true
    } else if (step > 1 && bulkSteps === 1 && assignmentMethod?.id === 1 && type1Validation) {
      return true;
    } else if (step > 1 && bulkSteps === 1 && assignmentMethod?.id === 2 && type2Validation) {
      return true;
    } else if (step > 2 && bulkSteps === 3 && bulkAddData?.length <= 0) {
      return true;
    }
    return false
  }, [step, assignmentMethod?.id, email, userName, selectedFormat?.id, credentialType?.id, credentialId, bulkSteps, bulkAddData, credentialRequired, selectedQRType?.id])


  const renderSteps = () => {
    switch (step) {
      case 1:
        return (
          <FlexColumn alignItems='start'>
            <Dropdown
              placeholder="Assignment Method"
              value={assignmentMethod?.name}
              onChange={(data) => {
                if (data?.id === 2 && credentialType?.id === 'apple_wallet') {
                  setCredentialType({ id: '', name: '' })
                }
                setAssignmentMethod(data);
              }}
              data={[{ id: 1, name: 'New Credential' }, { id: 2, name: 'Existing credential' }]}
            />

            <FlexColumn gap='0.5rem' alignItems='start'>
              <p>Credentials required</p>
              <RadioGroup style={{ flexDirection: 'row', width: '100%' }} aria-label="credential-required" name="credentialRequired" value={credentialRequired} onChange={(e) => { setCredentialRequired(e?.target?.value) }}>
                <FormControlLabel style={{ width: '50%' }} value="1" control={<StyledRadio />} label={"Single"} />
                {!isMobile && <FormControlLabel value="2" control={<StyledRadio />} label={"Multiple"} />}
              </RadioGroup>
            </FlexColumn>

            <Dropdown
              key={credentialType?.id}
              placeholder="Credential type"
              value={credentialType.name}
              onChange={(data) => {
                setCredentialType(data);
              }}
              data={assignmentMethod?.id === 2 ? credTypes?.filter(ct => ct?.id !== "apple_wallet") : credTypes}
            />

            {credentialType?.id === 'qr' &&
              <>
                <FlexColumn gap='0.5rem' alignItems='start'>
                  <p>QR Mode</p>
                  <RadioGroup style={{ flexDirection: 'row', width: '100%' }} aria-label="qr-mode" name="qrMode" value={qrMode} onChange={(e) => { setQrMode(e?.target?.value); setSelecetdQRType({ id: '', name: '' }) }}>
                    <FormControlLabel style={{ width: '50%' }} value="1" control={<StyledRadio />} label={"Static"} />
                    <FormControlLabel disabled={true} value="2" control={<StyledRadio />} label={"Dynamic (Coming Soon)"} />
                  </RadioGroup>
                </FlexColumn>

                {credentialRequired === "1" &&
                  <>
                    <Dropdown
                      key={`qr_type_${selectedQRType?.id}`}
                      placeholder="QR Type"
                      value={selectedQRType.name || undefined}
                      onChange={(data) => {
                        setSelecetdQRType(data);
                      }}
                      data={qrMode === "1" ? staticQRTypes : dynamicQRTypes}
                    />
                    <p style={{ color: '#656B70', marginTop: '1rem' }}><span style={{ color: '#084E8C', textDecoration: 'underline', cursor: 'pointer' }} onClick={() => { setInfoDialog(true) }}>Click here</span> to learn more about types of QR</p>
                  </>
                }
              </>
            }
          </FlexColumn>
        );
      case 2:
        return (
          <GenerateNewCredential
            assignmentMethod={assignmentMethod}
            setCredentialId={setCredentialId}
            credentialId={credentialId}
            email={email}
            setEmail={setEmail}
            selectedFormat={selectedFormat}
            userName={userName}
            setUserName={setUserName}
            setSelecetdFormat={setSelecetdFormat} />
        )

      case 3:
        return (
          <BulkUploadCredential bulkSteps={bulkSteps} setBulkSteps={setBulkSteps} assignmentMethod={assignmentMethod} setStep={setStep} setBulkAddData={setBulkAddData} qrMode={qrMode} credentialType={credentialType} />
        )
      default:
        break;
    }
  }

  const hBulkCreate = () => {
    const bulkMap = {}
    const qrTypes = qrMode === "1" ? staticQRTypes : dynamicQRTypes;
    const qrTypeMap = qrTypes.reduce((acc, item) => {
      acc[item.name] = item;
      return acc;
    }, {});
    for (let i = 0; i < bulkAddData?.length; i++) {
      const data = bulkAddData[i];
      const formattedCredData = {
        credentialType: credentialType?.id,
        credentialFormat: data?.format,
        credentialId: assignmentMethod?.id === 2 ? Number(data?.credential_id) : undefined,
      }

      if (credentialType?.id === 'qr') {
        formattedCredData["qrMode"] = Number(qrMode);
        formattedCredData["qrType"] = qrTypeMap[data?.qrType]?.id
      }

      if (bulkMap[data?.email]) {
        bulkMap[data?.email] = {
          email: data?.email,
          name: data?.name,
          credentialTypes: [
            ...bulkMap[data?.email]?.credentialTypes,
            formattedCredData,
          ]

        }
      } else {
        bulkMap[data?.email] = {
          email: data?.email,
          name: data?.name,
          credentialTypes: [formattedCredData]
        }
      }
    }
    const payload = {
      orgId: Number(customerId),
      orgName: organisation?.generalSetting?.name || '',
      credentials: Object?.values(bulkMap),
      partnerId: organisation?.generalSetting?.partnerId,
    }
    dispatch(doAddBulkCredentials(customerId, payload, () => { setSuccess(true); onSuccess() }));
  }

  const hNext = () => {
    if (credentialRequired === "2" && step >= 2) {
      if (bulkSteps >= 3) {
        hBulkCreate();
      } else {
        setBulkSteps(bulkSteps + 1);
        return;
      }
    }
    if (step <= 1) {
      setStep(credentialRequired === "2" ? 3 : 2);
      return;
    }

    if (credentialRequired === "1") {
      const payload = {
        orgName: organisation?.generalSetting?.name || '',
        email: email,
        partnerId: organisation?.generalSetting?.partnerId,
        name: userName,
        credentialTypes: [
          {
            credentialType: credentialType.id,
            credentialFormat: selectedFormat.id,
            credentialId: assignmentMethod?.id === 2 ? Number(credentialId) : undefined
          }
        ]
      }
      if (credentialType?.id === 'qr') {
        payload["credentialTypes"][0]["qrMode"] = Number(qrMode);
        payload["credentialTypes"][0]["qrType"] = selectedQRType?.id;
      }
      dispatch(doAddSingleCredential(customerId, payload, () => { setSuccess(true); onSuccess() }));
    }
  }

  const hBack = () => {
    if (credentialRequired === "2" && step === 3 && bulkSteps > 1) {
      setBulkSteps(bulkSteps - 1)
    } else if (credentialRequired === "2" && step >= 2) {
      setStep(1);
    } else {
      setStep(prev => (prev - 1))
    }
  }

  return (
    <>
      <SDialog
        title='Credential Type Info'
        open={infoDialog}
        onClose={() => {
          setInfoDialog(false);
        }}
        secondaryButtonConfig={{
          text: 'Cancel',
          onClick: () => {
            setInfoDialog(false);
          }
        }}
      >
        {(qrMode === "1" ? staticQrInfo : dynamicQrInfo)?.map(d => (
          <div style={{ marginBottom: '1rem' }}>
            <Typography variant='h7' style={{ fontWeight: 'bold' }}>{d?.title}</Typography>
            <Typography variant='b1' style={{ display: 'block' }}>{d?.description}</Typography>
          </div>
        ))}
      </SDialog>

      <SDialog
        title={'Add Credential'}
        open={open}
        onClose={popupToggle}
        isFormDialog={true}
        secondaryButtonConfig={{
          text: step > 1 ? 'Back' : 'Cancel',
          onClick: step > 1 ? hBack : popupToggle
        }}
        primaryButtonConfig={{
          text: step <= 1 ? 'Continue' : 'Next',
          onClick: hNext,
          disabled: hDisable
        }}
      >
        {renderSteps()}
      </SDialog>

      <SDialog
        title={'Successful'}
        open={success}
        onClose={popupToggle}
        primaryButtonConfig={{
          text: 'Done',
          onClick: popupToggle
        }}
      >
        <div className='column' style={{ gap: '1rem', width: '100%' }}>
          <SuccessTick />
          <p style={{ fontSize: '0.875rem' }}>Successfully generated credentials</p>
        </div>
      </SDialog>
    </>
  );
};

export default AddCredentialDialog;